export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        //
        // Mobile Menu Swiper - One Column
        //
        $('.dashboard-recent__swiper-container').each(function (item, value) {
            // console.log('hello world abc 123');
            new window.Swiper(
                value,
                {
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    // keyboard control
                    keyboard: {
                        enabled: true,
                    },
                    observer: true,
                    observeParents: true,
                    breakpoints: {
                        570: {
                            slidesPerView: 2.2,
                        },
                        750: { // next is lg @ 1040
                            slidesPerView: 3.2,
                        },
                        1040: {
                            slidesPerView: 4,
                        },
                    },
                }
            );
        });
    },
};
